import React, { useState, useEffect } from "react";
import { Grid, Button, Typography } from "@material-ui/core";
import CommentCard from "./commentCard";
import { makeStyles } from "@material-ui/core/styles";
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';

var apiURL = process.env.GATSBY_QUESTIONAPI;

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: '1em',
    paddingBottom: '2em',
    '& .Mui-selected': {
      background: '#3C465F;',
      color: 'white',
      fontFamily: 'Poppins',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '20px',
      height: '3.5em',
      width: '3.5em',
      borderRadius: '1.75em',
      [theme.breakpoints.down("sm")]: {
        height: '3em',
        width: '3em',
        borderRadius: '1.5em',
        fontSize: '9px'
      },
    },
    '& .MuiPaginationItem-ellipsis': {
      paddingTop: '.8em'
    },
    '& .MuiPaginationItem-icon': {
      fontSize: '1.5rem'
    },
    '& .MuiPaginationItem-root': {
      [theme.breakpoints.down('sm')]: {
        minWidth: 'initial !important'
      }
    },
    '& ul > li > button:not(.Mui-selected),.MuiPaginationItem-ellipsis': {
      backgroundColor: 'white',
      fontFamily: 'Poppins',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '20px',
      color: '#2F2F4E',
      height: '3.5em',
      width: '3.5em',
      borderRadius: '1.75em',
      [theme.breakpoints.down("sm")]: {
        height: '3em',
        width: '3em',
        borderRadius: '1.5em',
        fontSize: '9px'
      },
    },
    '& .MuiButtonBase-root': {
      padding: '8px !important'
    }
  },
  commentsWrapper: {
    width: '100%'
  }
}));

const ListComments = ({ itemsPerPage, pageId }) => {
  const [comments, setComments] = useState([]);
  const [displayComments, setDisplayComments] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [scrollTop, setScrollTop] = useState('');

  useEffect(() => {
    (() => {
      if (scrollTop != '') {
        window.location.href = "#comments";
      }
    })();
  }, [scrollTop]);

  useEffect(() => {
    (async () => {
      var commentsJson = await getAllComments();

      setComments(commentsJson);
    })();
  }, []);

  useEffect(() => {
    getComments(1);
  }, [comments]);

  var getAllComments = async function () {
    return fetch(apiURL + '/CommentsByPageId/Get?pageId=' + pageId, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((response) => response.json())
      .then((responseJson) => { return responseJson });
  }

  var getComments = function (pageNumber) {
    setPage(pageNumber);

    try {
      setTotalPages(Math.ceil(comments.length / itemsPerPage));
    } catch (e) {
      setTotalPages(0)
    }

    var slice = [];

    if (comments.length > 0) {
     setDisplayComments(comments.slice((pageNumber * itemsPerPage - itemsPerPage), pageNumber * itemsPerPage));
    }
  }

  const classes = useStyles();

  const handlePageChange = (event, value) => {
    setScrollTop(scrollTop + '.');

    getComments(value);
  };

  return (
    <div id="comments" className={classes.commentsWrapper}>
      {
        displayComments && displayComments.map((comment, index) => (
          <CommentCard comment={comment} />
        ))
      }
      <Grid container alignItems="center" justify="center">
        <Grid item>
          {totalPages > 1 &&
            <Pagination
              count={totalPages}
              className={classes.root}
              page={page}
              onChange={handlePageChange}
              renderItem={(item) => (
                <PaginationItem
                  {...item}
                  classes={{ selected: classes.selected }}
                />
              )}
            />}
        </Grid>
      </Grid>
    </div>
  );
};

export default ListComments;
